/**
 * perfect-scrollbar measures its content once, when the scroll area mounts, and
 * re-measures only when the ScrollBar element itself re-renders. Each My Work lane
 * fetches its own data and swaps a skeleton for a full list without re-rendering
 * its parent, so the scrollbar keeps the skeleton's height and refuses to scroll
 * until some unrelated re-render happens to force a re-measure. Watching the lane
 * content for resize gives it the one it never gets. #35295
 *
 * Returns a callback ref: React calls it with the element on mount and with null on
 * unmount, which is what disconnects the observer.
 */
export type ContentResizeSync = (el: HTMLElement | null) => void;

export const createContentResizeSync = (onResize: () => void): ContentResizeSync => {
  let observer: ResizeObserver | null = null;

  return (el: HTMLElement | null) => {
    observer?.disconnect();
    observer = null;

    if (!el || typeof ResizeObserver === 'undefined') return;

    observer = new ResizeObserver(onResize);
    observer.observe(el);
  };
};
